import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { SwapOrReturnState } from './SwapOrReturnTypes'

const selectFeature = (state: State) => state.swapOrReturn

export const selectFilteredStatus = createSelector(
  selectFeature,
  (state: SwapOrReturnState) => state.filteredStatus,
)
